import { DetectedWebView } from "@ciaopeople/cp-shatsu/ClientDetection/WebViewDetails.js";
import { BrowserLogger } from "@ciaopeople/cp-shatsu/Logging";
import { ExternalCloseUIElement, HasExternalUIElements } from "../../player/Player.js";
import { getProbeFile } from "./probe/ProbeFileDataUrl.js";
import { WrappedImaAdsManager } from "./AbstractImaController.js";
//import { getProbeFile } from "./probe/ProbeFileBlobAsset.js";


export interface UnmuteInfo {
    unmutedAtStart: boolean,
    gesture: boolean,
    directInteraction: boolean,
    firstCheck?: boolean
}

export const AUDIO_ON_VAST_WRAPPER_ID_PREFIX = "cp908712032124";

export const AUDIO_ON_VIEWABILITY_TIMEOUT = 6000;


export function isAnyUnmutable(ui: UnmuteInfo): boolean {
    return ui && (ui.directInteraction || ui.gesture || ui.unmutedAtStart);
}

export function isUnmutableByDirectInteraction(ui: UnmuteInfo): boolean {
    return ui && ui.directInteraction;
}

export function isUnmutableByGesture(ui: UnmuteInfo): boolean {
    return ui && ui.gesture;
}

export function isUnmutableFromStart(ui: UnmuteInfo): boolean {
    return ui && ui.unmutedAtStart;
}

export function isNotUnmutable(ui: UnmuteInfo): boolean {
    return !isAnyUnmutable(ui);
}

export function isFullyUnmutable(ui: UnmuteInfo): boolean {
    return ui && ui.directInteraction && ui.gesture && ui.unmutedAtStart;
}

export function isStronglyUnmutable(ui: UnmuteInfo): boolean {
    return isUnmutableByDirectInteraction(ui) || isUnmutableFromStart(ui);
}

export function isUnmutableForAllGestures(ui: UnmuteInfo): boolean {
    return isUnmutableByGesture(ui) && isUnmutableByDirectInteraction(ui);
}

export function firstUnumuteCheckDone(ui: UnmuteInfo): boolean {
    return ui && ui.firstCheck;
}


export function neverUnmute(ui: UnmuteInfo): boolean {
    return false;
}

export interface UserGestureUnmuter {


    whenIsFirstUnmutable(listner: UnmuteListener): void;
    currentUnmuteStatus(): UnmuteInfo;

    onUnmuteConditionChange(listener: UnmuteListener): void;
    offUnmuteConditionChange(listener: UnmuteListener): void;

    onFirstCheck(listener: UnmuteListener): void;
}


const UNMUTE_VOLUME_VALUE_MOBILE = 1;
const UNMUTE_VOLUME_VALUE_DESKTOP = 0.1;

const USER_GESTURES = [
    'click', 'contextmenu', 'auxclick', 'dblclick', 'mousedown',
    'mouseup', 'pointerup', 'keydown', 'keyup'
];

export interface IMAUnmuter {
    beforeAdStart(manager: google.ima.AdsManager, info: google.ima.Ad): void;
    declareMute(): boolean;
}




export class NoOpUnumuter implements UserGestureUnmuter {

    private readonly staticData: UnmuteInfo = {
        directInteraction: false,
        gesture: false,
        unmutedAtStart: false,
        firstCheck: true
    };

    whenIsFirstUnmutable(listner: UnmuteListener): void {

    }
    currentUnmuteStatus(): UnmuteInfo {
        return this.staticData;

    }

    onUnmuteConditionChange(listener: UnmuteListener): void {

    }
    offUnmuteConditionChange(listener: UnmuteListener): void {

    }

    onFirstCheck(listener: UnmuteListener): void {
        listener(null, this.staticData);
    }


}


export class IMAFollowVideoStatusUnmuter implements IMAUnmuter {

    constructor(private video: HTMLVideoElement, private externalUIElements: HasExternalUIElements) {

    }

    beforeAdStart(manager: google.ima.AdsManager, info: google.ima.Ad): void {

    }
    declareMute(): boolean {
        return this.video.muted;
    }

}


export type UnmutePolicy = (u: UnmuteInfo) => boolean


export type IMAUnmuterConfig = {
    seekOnlyForTrueviewInDefaultPolicy: boolean,
    policies: {
        defaultPolicy: UnmutePolicy,
        [k: string]: UnmutePolicy
    }
};

export const IMAUnmuterStandardConfig: IMAUnmuterConfig = {
    policies: {
        defaultPolicy: isStronglyUnmutable,
        [AUDIO_ON_VAST_WRAPPER_ID_PREFIX]: isAnyUnmutable
    },
    seekOnlyForTrueviewInDefaultPolicy: true
}


export const IMAUnmuterConservativeConfig: IMAUnmuterConfig = {
    policies: {
        defaultPolicy: neverUnmute,
        [AUDIO_ON_VAST_WRAPPER_ID_PREFIX]: isAnyUnmutable
    },
    seekOnlyForTrueviewInDefaultPolicy: false
}


export enum AdCloseButtonHidePolicy {

    NEVER_HIDE = "never",
    HIDE_ONLY_FOR_SPECIFIC_ADS = "specific_only",
    HIDE_ALWAYS = 2


}

export class IMAAdvancedUnmuter implements IMAUnmuter {


    private endEventsOfInterest = [
        google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
        google.ima.AdEvent.Type.USER_CLOSE,
        google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
        google.ima.AdEvent.Type.SKIPPED,
        google.ima.AdEvent.Type.COMPLETE
    ]

    private progressEvent = [
        google.ima.AdEvent.Type.AD_PROGRESS,
        google.ima.AdEvent.Type.IMPRESSION
    ]


    private wrapperIdsKeys: string[];

    private startEventsOfInterst = [
        google.ima.AdEvent.Type.STARTED,
        // google.ima.AdEvent.Type.RESUMED
        // google.ima.AdEvent.Type.AD_PROGRESS
    ]

    constructor(private wrappedUnmuter: UserGestureUnmuter,
        private videoEl: HTMLVideoElement,
        private externalUIElements: HasExternalUIElements,
        private deviceDetect: DetectedWebView,
        private config: IMAUnmuterConfig = IMAUnmuterStandardConfig,
        private hidePolicy: AdCloseButtonHidePolicy = AdCloseButtonHidePolicy.HIDE_ALWAYS
    ) {

        this.wrapperIdsKeys = Object.keys(this.config.policies).filter(e => e != "defaultPolicy");

    }




    private uiCycleProperty(manager: google.ima.AdsManager, endTrigger: "impression" | "viewtime", action: "hide" | "disable", viewTimeTrigger: number = AUDIO_ON_VIEWABILITY_TIMEOUT) {

        //gestione h/s (x) audio-on camp.
        const ext = this.externalUIElements.getCloseExternalUIElement();
        if (ext != null) {
            if (action == "hide") ext.show(false);
            ext.enabled(false);
        }

        let xShowCallback: (evt: google.ima.AdEvent) => void = null;
        let progressCallback: (evt: google.ima.AdEvent) => void = null;
        let completable: boolean = false;

        const showAndUnregister = () => {
            const ext2 = this.externalUIElements.getCloseExternalUIElement();
            if (ext2 != null) {
                if (action == "hide") ext2.show(true);
                ext2.enabled(true);
            }
            if (xShowCallback) {
                this.endEventsOfInterest.forEach((evt) => {
                    manager.removeEventListener(evt, xShowCallback);
                });
            }
            if (progressCallback) {
                this.progressEvent.forEach(evt => {
                    manager.removeEventListener(evt, progressCallback);
                });
            }
        }

        xShowCallback = () => {
            showAndUnregister();
        }
        progressCallback = (evt: google.ima.AdEvent) => {


            const currentTime: number = evt.getAdData()?.currentTime;
            const duration: number = evt.getAdData()?.duration;

            if (completable && endTrigger == "impression" && evt.type == google.ima.AdEvent.Type.IMPRESSION) {
                showAndUnregister();
            }

            if (completable && !(typeof currentTime == "undefined") && !(typeof duration == "undefined")) {

                if ((currentTime * 1000) >= viewTimeTrigger) {
                    showAndUnregister();
                }
            }
        }


        if (xShowCallback) {
            this.endEventsOfInterest.forEach((evt) => {
                manager.addEventListener(evt, xShowCallback);
            });
        }
        if (progressCallback) {
            this.progressEvent.forEach((evt) => {
                manager.addEventListener(evt, progressCallback);
            });
            const dostart = () => {
                completable = true;
                this.startEventsOfInterst.forEach((evt) => {
                    manager.removeEventListener(evt, dostart);
                })
            }
            this.startEventsOfInterst.forEach((evt) => {
                manager.addEventListener(evt, dostart);
            })
        }

    }

    beforeAdStart(manager: google.ima.AdsManager, info: google.ima.Ad): void {


        let shouldUnmute = !this.videoEl.muted;
        console.log("[AGGRO] is video el um?", shouldUnmute);

        let retrievedAdSpecificPolicy: UnmutePolicy = null;
        let specificPolicyKey: string = null;
        if (info && info.getWrapperAdIds()) {
            const maybeKey = this.wrapperIdsKeys.find(key => info.getWrapperAdIds().findIndex(wrap => wrap.startsWith(key)) >= 0);
            if (maybeKey && maybeKey in this.config.policies) {
                retrievedAdSpecificPolicy = this.config.policies[maybeKey];
                specificPolicyKey = maybeKey;
            }
        }

        let deferredPolicy: UnmutePolicy = null;
        if (!shouldUnmute && this.config.policies.defaultPolicy(this.wrappedUnmuter.currentUnmuteStatus())) {
            if (this.config.seekOnlyForTrueviewInDefaultPolicy) {
                const adSystem = info.getAdSystem();
                const wrappedAdSystems = info.getWrapperAdSystems();
                const skipTime = info.getSkipTimeOffset();
                const adexRegex = /(adsense|adex)/i;
                console.log("[AGGRO] seeking for tw", adSystem, wrappedAdSystems, skipTime);
                if (adSystem && adSystem.match(adexRegex) && skipTime > 0) {
                    console.log("[AGGRO] enabiling on tw");
                    shouldUnmute = true;
                }
            }
            else {
                console.log("[AGGRO] um by default policy", this.wrappedUnmuter.currentUnmuteStatus());
                shouldUnmute = true;
            }
        }

        if (!shouldUnmute) {


            if (retrievedAdSpecificPolicy) {

                shouldUnmute = retrievedAdSpecificPolicy(this.wrappedUnmuter.currentUnmuteStatus());
                if (!shouldUnmute) {
                    console.log("[AGGRO] Deferring on", specificPolicyKey);
                    deferredPolicy = retrievedAdSpecificPolicy;
                }
                else {
                    console.log("[AGGRO] UM on", specificPolicyKey, this.wrappedUnmuter.currentUnmuteStatus());
                }
            }


        }

        if (this.hidePolicy == AdCloseButtonHidePolicy.HIDE_ALWAYS ||
            (this.hidePolicy == AdCloseButtonHidePolicy.HIDE_ONLY_FOR_SPECIFIC_ADS && specificPolicyKey)) {

            if (specificPolicyKey) this.uiCycleProperty(manager, "viewtime", "hide", 2500);
            else this.uiCycleProperty(manager, "impression", "disable");


        }

        if (shouldUnmute || deferredPolicy) {

            const wasMuted = this.videoEl.muted;
            const previousVolume = this.videoEl.volume;
            const isDesktop = this.deviceDetect?.device?.other;
            const applyVolume = isDesktop ? UNMUTE_VOLUME_VALUE_DESKTOP : UNMUTE_VOLUME_VALUE_MOBILE;

            //console.log("[AGGRO] unmad", isDesktop);

            const unmuteExec = () => {

                this.videoEl.muted = false;
                manager.setVolume(applyVolume);
                if (isDesktop && wasMuted) {
                    this.videoEl.volume = applyVolume;
                }
                this.startEventsOfInterst.forEach((evt) => {
                    manager.removeEventListener(evt, startCallback);
                });
            }

            const deferredListener = (evt: Event, uinfo: UnmuteInfo) => {
                if (deferredPolicy && deferredPolicy(uinfo)) {
                    console.log("[AGGRO] unmuting on deferred policy");
                    unmuteExec();
                    this.wrappedUnmuter.offUnmuteConditionChange(deferredListener);
                }
            }


            const startCallback = () => {

                if(shouldUnmute) unmuteExec();
                else if(deferredPolicy) {
                    console.log("[AGGRO] deferring policy");
                    this.wrappedUnmuter.onUnmuteConditionChange(deferredListener);
                }

            }

            this.startEventsOfInterst.forEach((evt) => {
                manager.addEventListener(evt, startCallback);
            });

            if (wasMuted || isDesktop) {
                const endCallback = () => {
                    this.videoEl.muted = true;
                    if (deferredListener) this.wrappedUnmuter.offUnmuteConditionChange(deferredListener);
                    if (isDesktop) {
                        this.videoEl.volume = previousVolume;
                    }
                    this.endEventsOfInterest.forEach((evt) => {
                        manager.removeEventListener(evt, endCallback);
                    });
                }
                this.endEventsOfInterest.forEach((evt) => {
                    manager.addEventListener(evt, endCallback);
                })
            }


        }
    }


    declareMute(): boolean {
        return this.videoEl.muted && !this.config.policies.defaultPolicy(this.wrappedUnmuter.currentUnmuteStatus());
    }


}


export class ImaUserGestureUnmuterMulinoBiancoImpl implements IMAUnmuter {

    constructor(private wrappedUnmuter: UserGestureUnmuter) {

    }




    beforeAdStart(manager: google.ima.AdsManager, info: google.ima.Ad) {
        const isUnMutableAds = info && info.getWrapperAdIds() && info.getWrapperAdIds().filter(value => value.startsWith(AUDIO_ON_VAST_WRAPPER_ID_PREFIX)).length

        console.log("UNMUTABLE AD? ", isUnMutableAds)
        console.log("muted admanager? ", manager.getVolume())
        if (isUnMutableAds && manager.getVolume() < UNMUTE_VOLUME_VALUE_MOBILE) {
            this.wrappedUnmuter.whenIsFirstUnmutable(() => {
                manager.setVolume(UNMUTE_VOLUME_VALUE_MOBILE)
            });
        }

    }

    declareMute(): boolean {
        return true;
    }
}

type UnmuteListener = (e: Event, ui: UnmuteInfo) => void

export class BaseUnmuter implements UserGestureUnmuter {


    private uinfo: UnmuteInfo;
    private readonly userInputEventNames = USER_GESTURES;

    private firstUnmuteListeners: UnmuteListener[];
    private onNextUnumuteListeners: UnmuteListener[];
    private firstCheckListeners: UnmuteListener[];
    private logger: BrowserLogger;



    constructor(private rootElement: HTMLElement, private mediaElement: HTMLMediaElement) {

        this.uinfo = {
            directInteraction: false,
            unmutedAtStart: false,
            gesture: false
        };

        this.firstUnmuteListeners = [];
        this.onNextUnumuteListeners = [];
        this.firstCheckListeners = [];

        this.logger = new BrowserLogger("AGGRO");

        const funcUserGesture = (e: Event) => {
            setTimeout(() => {
            const oldvalues = { ...this.uinfo };
            this.uinfo.gesture = true;
            this.uinfo.directInteraction = this.rootElement.contains(e.target as HTMLElement);
            //
            if (isUnmutableForAllGestures(this.uinfo)) {
                this.userInputEventNames.forEach((eventName) => {
                    document.removeEventListener(eventName, funcUserGesture);
                });
            }
            if (oldvalues.gesture != this.uinfo.gesture || oldvalues.directInteraction != this.uinfo.directInteraction) {
                this.triggerNext(e);
            }

            },0);
        };
        const useProbeVideo = this.mediaElement.src ? false : true;
        //nb: ATTENZIONE allontanarsi dalla linea gialla
        //il metodo sblocca quando hai il loadedmetadata
        //quindi la src del media deve essere inserita altrimenti attende
        const oldSrc = this.mediaElement.src;
        if (useProbeVideo) {
            this.logger.log("Setting probe media");
            this.mediaElement.preload = "metadata"
            this.mediaElement.src = getProbeFile();
            //this.videoElement.load();
        }
        this.mediaElement.muted = false;
        this.mediaElement.play().then(() => {
                    this.mediaElement.muted = true;
                    this.logger.log("Can play with audio on directly");
                    this.mediaElement.pause();
                    if (useProbeVideo) this.mediaElement.src = "";
                    this.uinfo.unmutedAtStart = true;
                    this.uinfo.firstCheck = true;
                    this.triggerNext(null);
                }).catch((err) => {
                    this.mediaElement.muted = true;
                    this.logger.log("Could not play audio on directly");
                    this.uinfo.firstCheck = true;
                    this.uinfo.unmutedAtStart = false;
                    if (useProbeVideo) this.mediaElement.src = "";
                    this.triggerNext(null);
        });


        this.userInputEventNames.forEach((eventName) => {
            document.addEventListener(eventName, funcUserGesture);
        });

    }


    private triggerNext(maybeEvt: Event): void {

        if (this.uinfo.firstCheck) {
            this.logger.debug("Updated uinfo", this.uinfo);
            let useListeners = this.onNextUnumuteListeners;
            if (this.firstCheckListeners) {
                useListeners = useListeners.concat(this.firstCheckListeners);
                this.firstCheckListeners = null;
            }
            if (isAnyUnmutable(this.uinfo)) {
                useListeners = useListeners.concat(this.firstUnmuteListeners);
                this.firstUnmuteListeners = [];
            }

            useListeners.forEach((l) => {
                try {
                    this.logger.debug("Running listener on change");
                    l(maybeEvt, this.uinfo)
                }
                catch (e) {
                    this.logger.error("error running interaction listener", e);
                }
            });
            this.firstUnmuteListeners = [];

            if (isFullyUnmutable(this.uinfo)) {
                this.onNextUnumuteListeners = [];
            }
        }
    }

    onUnmuteConditionChange(listener: UnmuteListener): void {
        if (isFullyUnmutable(this.uinfo)) {
            setTimeout(() => listener(null, this.uinfo), 0);
        }
        else this.onNextUnumuteListeners.push(listener);
    }

    offUnmuteConditionChange(listener: UnmuteListener): void {
        this.onNextUnumuteListeners.filter(l => l == listener);
    }
    whenIsFirstUnmutable(listener: UnmuteListener): void {
        if (isAnyUnmutable(this.uinfo)) {
            setTimeout(() => listener(null, this.uinfo), 0);
        }
        else this.firstUnmuteListeners.push(listener);
    }

    currentUnmuteStatus(): UnmuteInfo {
        return this.uinfo;
    }

    onFirstCheck(listener: UnmuteListener): void {
        if (this.uinfo.firstCheck) {
            setTimeout(() => listener(null, this.uinfo), 0);
        }
        else this.firstCheckListeners.push(listener);
    }
}
